const routerModules = import.meta.glob([
  '@/views/**/*.vue',
  '!@/views/**/*copy.vue',
  '!@/views/**/component',
  '!@/views/**/components',
  '!@/views/**/composables',
  '!@/views/**/hooks',
  '!@/views/**/locales',
  '!@/views/**/modules',
  '!@/views/**/plugins',
  '!@/views/**/tests',
  '!@/views/**/test',
  '!@/views/common',
])
export const basicRouteMap = {
  // iframe
  Iframe: () => import('@/views/common/iframe.vue'),
  // Thường được sử dụng cho các trang có tập hợp con
  RouteView: () => import('@/layouts/route-view.vue'),
  // Lỗi
  ComponentError: () => import('@/views/exception/component-error.vue'),
}

function checkEager(module: any) {
  if (typeof module === 'object' && 'default' in module) return module.default

  return module
}
export function getRouterModule(path?: string): any {
  if (!path) return basicRouteMap.ComponentError
  // Kiểm tra xem có tồn tại trong basicRouteMap không
  if (path in basicRouteMap) return (basicRouteMap as any)[path]

  // Kiểm tra xem có bắt đầu bằng / không
  if (path.startsWith('/')) path = path.slice(1)
  // Lắp ráp định dạng dữ liệu
  const fullPath = `/src/views/${path}.vue`
  const fullPathIndex = `/src/views/${path}/index.vue`
  if (fullPathIndex in routerModules) return checkEager(routerModules[fullPathIndex])

  // Trả về thông tin plugin
  return checkEager(routerModules[fullPath])
}

export default routerModules
